import { Component, OnInit, ViewEncapsulation, OnDestroy, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, filter, delay, takeUntil } from 'rxjs';
import { isPlatformServer } from '@angular/common';

import { FAQ_SECTIONS } from './content.data';
import { FaqSection } from './faq.model';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FaqComponent implements OnInit, OnDestroy {
  faqSections: FaqSection[] = FAQ_SECTIONS;
  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
    this.handleFragmentNavigation();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private handleFragmentNavigation(): void {
    if (isPlatformServer(this.platformId)) return;

    this.route.fragment.pipe(
      filter(Boolean),
      delay(500), // Delay to ensure DOM is fully ready
      takeUntil(this.destroy$)
    ).subscribe((fragment: string) => {
      if (fragment === 'support') {
        this.scrollToSupportSection();
      }
    });
  }

  private scrollToSupportSection(): void {
    const supportElement = document.getElementById('support');
    if (supportElement) {
      const offsetTop = supportElement.offsetTop - 100; // 100px offset for better visibility
      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }
  }

}
